export const FETCH_CREATE_SITE_USER = 'views/users/FETCH_CREATE_SITE_USER'
